import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { MessagesStore } from '../messages/stores';
import * as styles from "./MessageCompactListView.css";
import { IMessage } from '../../interfaces/IMessage';
import { ILike } from '../../interfaces/ILike';
import { CompactListElement } from '../compactListElement/CompactListElement';

export interface ICompactListViewProps {
  messagesStore?: MessagesStore;
}

@inject('messagesStore')
@observer
export class CompactListView extends React.Component<ICompactListViewProps> {

  constructor(props) {
    super(props);
  }

  private skeletonList(): JSX.Element[] {
    let skeletonListItems = [];
    let numMessages = this.props.messagesStore.numMessages > 20 ? 20 : this.props.messagesStore.numMessages;
    for (let i = 0; i < numMessages; i++) {
      skeletonListItems.push(
        <div
          className={styles.IA_skeleton}
          style={{
            height: this.props.messagesStore.isMobile ? 54 : 38
          }}
          key={`skeletonListItem_${i}`}
        />
      );
    }
    return skeletonListItems;
  }

  public render(): JSX.Element {
    let messagesToDisplay = [];
    let itemsToShow: IMessage[] = [];
    let widthTopMinusFromContentArea = 0;
    if (this.props.messagesStore.showLikes && this.props.messagesStore.showComments) {
      widthTopMinusFromContentArea = widthTopMinusFromContentArea + 80;
    }
    if (this.props.messagesStore.showLikes && !this.props.messagesStore.showComments) {
      widthTopMinusFromContentArea = widthTopMinusFromContentArea + 54;
    }
    if (!this.props.messagesStore.showLikes && this.props.messagesStore.showComments) {
      widthTopMinusFromContentArea = widthTopMinusFromContentArea + 54;
    }
    if (this.props.messagesStore.messages) {
      if (this.props.messagesStore.isMobile) {
        itemsToShow = this.props.messagesStore.messages;
      } else {
        const startIndex = (this.props.messagesStore.pageNumber - 1) * this.props.messagesStore.numMessages;
        const endIndex = this.props.messagesStore.pageNumber * this.props.messagesStore.numMessages;
        itemsToShow = this.props.messagesStore.messages.slice(startIndex, endIndex)
      }
      itemsToShow.forEach((message: IMessage) => {
        let author = message.author;
        let hasCategories = false;
        if (message.categories !== undefined && message.categories.length > 0) {
          hasCategories = true;
        }
        if (message.contacts != undefined && message.contacts.length > 0) {
          author = message.contacts[0];
        }
        const displayUnread = !message.isRead && this.props.messagesStore.instance?.settings?.enableReadUnreadMessage;
        messagesToDisplay.push(

          <CompactListElement
            id={message.id}
            hasCategories={hasCategories}
            textColor={this.props.messagesStore.textColor}
            highlightColor={this.props.messagesStore.rollupHighlightColor}
            author={author?.displayName}
            date={message.startDate}
            title={message.title}
            backgroundColor={this.props.messagesStore.backgroundColor}
            borderRadius={this.props.messagesStore.borderRadius}
            borderColor={this.props.messagesStore.borderColor}
            showDropShadow={this.props.messagesStore.showDropShadow}
            onClick={() => this.props.messagesStore.openMessage(message)}
            showDate={this.props.messagesStore.showStartDate}
            showAuthor={this.props.messagesStore.showAuthor}
            showCategories={this.props.messagesStore.showCategories}
            showComments={this.props.messagesStore.showComments}
            showLikes={this.props.messagesStore.showLikes}
            widthTopMinusFromContentArea={widthTopMinusFromContentArea}
            width={this.props.messagesStore.width}
            isMobile={this.props.messagesStore.isMobile}
            fontSlots={this.props.messagesStore.fontSlots}
            userLocation={this.props.messagesStore.userLocation}
            category={message.categories[0] ?? undefined}
            commentsEnabled={this.props.messagesStore.commentsEnabled}
            disableComments={message.iaConfiguration?.disableComments}
            user={this.props.messagesStore.user}
            tenant={this.props.messagesStore.tenant}
            token={this.props.messagesStore.token}
            component={this.props.messagesStore.component}
            environment={this.props.messagesStore.environment}
            instance={this.props.messagesStore.instance}
            displayUnread={displayUnread}
            commentsClick={() => this.props.messagesStore.commentsClick(message)}
            linkColor={this.props.messagesStore.rollupHighlightColor}
            source={this.props.messagesStore.source}
            likesEnabled={this.props.messagesStore.likesEnabled}
            likes={message.likes}
            likesUpdated={(likes: ILike[]) => { message.likes = likes; }}
            commentsCount={message.commentCount}
            commentsUpdated={(comments: number) => message.commentCount = comments}
            disableLikes={message.iaConfiguration?.disableLikes}
            showEmojiPickerExpandButton={this.props.messagesStore.instance?.settings?.showEmojiPickerExpandButton}
            reactionOptions={this.props.messagesStore.instance?.settings?.reactionOptions}
            showLikesDimmed={this.props.messagesStore.loadingCommentsAndLikes && this.props.messagesStore.showLikes && !message.iaConfiguration?.disableLikes}
            showCommentsDimmed={this.props.messagesStore.loadingCommentsAndLikes && this.props.messagesStore.showComments && !message.iaConfiguration?.isNewsLink && !message.iaConfiguration?.disableComments}
            fieldsToHide={message?.iaConfiguration?.fieldsToHide}
          />
        );
      });
    }
    let showSkeleton = this.props.messagesStore.loading;
    if (this.props.messagesStore.loading && this.props.messagesStore.isMobile && this.props.messagesStore.messages && this.props.messagesStore.messages.length > 0) {
      showSkeleton = false;
    }
    return this.props.messagesStore.width != undefined ? (
      <div
        style={{
          width: "calc(100% - 2px)",
          overflow: "hidden",
          height: "auto",
          padding: "0px 1px"
        }}
      >
        {showSkeleton ?
          this.skeletonList()
          :
          messagesToDisplay
        }
      </div>
    )
      :
      (
        <div
          style={{
            width: "calc(100% - 2px)",
            overflow: "hidden",
            height: "auto",
            padding: "0px 1px"
          }}
        ></div>
      );
  }


}